import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicInterconnection = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Interconnection of Components"
      videos={[
        "https://www.youtube.com/embed/TgYAj7mlRT8", 
      ]}
      takeaways={[

        { text: "Remember the diagram for bus architecture" ,
            image: "/cao_1.png"},
        { text: "Direct theory question is possible." },
      ]}
      questions={[]} // Add questions if needed
      exampleVideos={[]} // Add example question videos if needed
    />
);
}

export default ModuleSubtopicInterconnection;
